module.exports = __webpack_public_path__ + "static/sales-12e358f2d847c9ec583d62450a82c2cc.png";